























import Modal from '@/components/mixins/Modal';

import { MediaSource } from '@/services/Media';

import imdbTop100RatedMovies from '@/assets/data/imdb-top-100-rated-movies.json';

export default Modal.extend({
    methods: {
        async importImdbTop100RatedMovies() {
            await this.$media.importMovies(imdbTop100RatedMovies, MediaSource.JSONLD);

            this.close();
        },
    },
});
